var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeliz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3826_30377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.11 73.1095C88.4254 59.7942 88.4254 38.2058 75.11 24.8905C61.7947 11.5752 40.2063 11.5752 26.891 24.8905C13.5757 38.2058 13.5757 59.7942 26.891 73.1095C40.2063 86.4248 61.7947 86.4248 75.11 73.1095Z",
    fill: "#FFD05D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.8359 19.9C72.9895 26.4021 74.8153 34.1206 74.015 41.7945C73.2147 49.4684 69.8357 56.6441 64.4299 62.1492C59.0241 67.6544 51.9112 71.1636 44.2531 72.1035C36.595 73.0434 28.8446 71.3585 22.2679 67.324C25.0294 71.642 28.7289 75.2819 33.0911 77.9728C37.4534 80.6638 42.3662 82.3367 47.4642 82.8671C52.5622 83.3974 57.7142 82.7715 62.537 81.0361C67.3597 79.3006 71.7291 76.5001 75.3203 72.843C78.9114 69.1859 81.6318 64.7662 83.2791 59.9126C84.9265 55.0591 85.4584 49.8965 84.8353 44.8091C84.2122 39.7216 82.4501 34.84 79.6801 30.5275C76.9101 26.2149 73.2035 22.5824 68.8359 19.9Z",
    fill: "#FDC453"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.54 52.6C21.54 45.9888 23.6099 39.5436 27.4592 34.1686C31.3085 28.7936 36.7441 24.7587 43.0032 22.63C49.2622 20.5013 56.0307 20.3856 62.3589 22.2992C68.6871 24.2128 74.2573 28.0597 78.288 33.3C76.1285 29.5383 73.2191 26.2605 69.7402 23.6699C66.2614 21.0793 62.2873 19.2312 58.0646 18.2402C53.8419 17.2491 49.4605 17.1364 45.1924 17.9089C40.9243 18.6813 36.8604 20.3226 33.2529 22.7308C29.6454 25.139 26.5712 28.2628 24.221 31.9084C21.8709 35.554 20.2949 39.6436 19.5908 43.9235C18.8867 48.2035 19.0696 52.5824 20.1281 56.7888C21.1866 60.9951 23.0981 64.9391 25.744 68.376C22.9834 63.577 21.5335 58.1364 21.54 52.6Z",
    fill: "#FFD77F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.952 40.7281C40.952 43.0681 39.828 44.9641 38.44 44.9641C37.052 44.9641 35.928 43.0681 35.928 40.7281C35.928 38.3881 37.052 36.4921 38.44 36.4921C39.828 36.4921 40.952 38.3881 40.952 40.7281Z",
    fill: "#303030"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.072 40.7281C66.072 43.0681 64.948 44.9641 63.56 44.9641C62.172 44.9641 61.048 43.0681 61.048 40.7281C61.048 38.3881 62.172 36.4921 63.56 36.4921C64.948 36.4921 66.072 38.3881 66.072 40.7281Z",
    fill: "#303030"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0919 52.224C28.7326 57.8509 31.4217 63.0451 35.6467 66.8163C39.8716 70.5875 45.3367 72.6718 50.9999 72.6718C56.6631 72.6718 62.1282 70.5875 66.3532 66.8163C70.5781 63.0451 73.2673 57.8509 73.9079 52.224H28.0919Z",
    fill: "#695342"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.176 66.3761C39.3609 70.3321 44.8756 72.5773 50.6336 72.6691C56.3916 72.7609 61.9752 70.6927 66.284 66.8721L66.072 66.3761C50.688 58.8761 35.4 66.2721 35.176 66.3761Z",
    fill: "#F06669"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3826_30377",
    x: 0.904541,
    y: 0.904053,
    width: 100.192,
    height: 100.192,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3826_30377"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3826_30377",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeliz);
export default __webpack_public_path__ + "static/media/feliz.d793df6fa951df348d458ab8100ef53e.svg";
export { ForwardRef as ReactComponent };